import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from '../utils/trackAddToCart';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
export function SalesLetter() {
  return <section className="w-full" style={{
    background: 'var(--bg-surface)'
  }} aria-label="Carta de ventas" data-id="element-183">
      <div className="max-w-2xl mx-auto px-4 py-10 md:py-16" data-id="element-184">
        {/* ── Pain Points ── */}
        <div className="mb-10" data-id="element-185">
          <div className="section-accent" data-id="element-186" />
          <p className="eyebrow text-center mb-3" data-id="element-187">¿Te suena familiar?</p>
          <h2 className="text-2xl md:text-3xl text-center mb-7" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-188">
            Este sistema es para vos si alguna vez...
          </h2>

          <div className="space-y-3" data-id="element-189">
            <div className="pain-card" data-id="element-190">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-191">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-192">
                Terminás{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-193">
                  pidiendo delivery por agotamiento
                </strong>{' '}
                y después sentís culpa por el gasto y la mala alimentación.
              </p>
            </div>
            <div className="pain-card" data-id="element-194">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-195">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-196">
                Intentás organizarte el domingo pero{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-197">
                  para el martes ya estás improvisando de vuelta.
                </strong>
              </p>
            </div>
            <div className="pain-card" data-id="element-198">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-199">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-200">
                Vivís lavando platos a cualquier hora como si{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-201">
                  tu cocina fuera un restaurante que nunca cierra.
                </strong>
              </p>
            </div>
            <div className="pain-card" data-id="element-202">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-203">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-204">
                Sentís que{' '}
                <strong style={{
                color: 'var(--text-primary)'
              }} data-id="element-205">
                  comer bien requiere tiempo y plata que simplemente no tenés.
                </strong>
              </p>
            </div>
            <div className="pain-card" data-id="element-206">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-207">❌</span>
              <p className="text-sm md:text-base leading-relaxed m-0" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-208">
                <em data-id="element-209">
                  Sentir que no te alcanza el tiempo (ni la energía, ni las
                  ganas) para darle a tu familia la alimentación que se merece.
                </em>
              </p>
            </div>
          </div>
        </div>

        {/* ── Product Intro ── */}
        <div className="text-center mb-10" data-id="element-210">
          <p className="eyebrow mb-3" data-id="element-211">Presentamos...</p>
          <h2 className="text-3xl md:text-4xl mb-2" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-212">
            <span style={{
            textDecoration: 'underline',
            textDecorationColor: 'var(--color-gold)',
            textUnderlineOffset: '5px',
            textDecorationThickness: '1.5px'
          }} data-id="element-213">
              Sistema 10x2™
            </span>
          </h2>
          <p className="text-base md:text-lg italic mb-7" style={{
          fontFamily: 'var(--font-heading)',
          color: 'var(--text-muted)',
          fontWeight: 500
        }} data-id="element-214">
            "La Guía Definitiva Para Resolver Tu Cocina De Una Vez Por Todas"
          </p>

          {/* Product mockup */}
          <div className="w-full max-w-xs mx-auto rounded-2xl mb-5 overflow-hidden" style={{
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-md)'
        }} aria-label="Mockup producto Sistema 10x2™" data-id="element-215">
            <img src="https://cdn.magicpatterns.com/uploads/avXfojrAUQ7PsUmUipPzNu/20260303_1146_Image_Generation_remix_01kjt2hag0fe6swnp6e4ws1vcz_(1).webp" alt="Sistema 10x2™ — Producto completo con bonos" className="w-full h-auto object-cover" style={{
            display: 'block'
          }} data-id="element-216" />
          </div>

          <p className="text-xs font-semibold uppercase tracking-widest mb-5" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-muted)',
          letterSpacing: '0.18em'
        }} data-id="element-217">
            Producto Digital — Descarga Inmediata
          </p>

          {/* Product name badge */}
          <div className="inline-block px-6 py-4 rounded-xl mb-5" style={{
          background: 'var(--bg-dark)',
          color: 'var(--text-inverse)'
        }} data-id="element-218">
            <p className="text-lg font-bold m-0" style={{
            fontFamily: 'var(--font-heading)',
            letterSpacing: '-0.01em'
          }} data-id="element-219">
              Sistema 10x2™
            </p>
            <p className="text-xs m-0 mt-1" style={{
            fontFamily: 'var(--font-body)',
            color: 'rgba(255,255,255,0.5)',
            letterSpacing: '0.04em'
          }} data-id="element-220">
              10 Días de Comida · 2 Horas de Cocina · Cero Estrés
            </p>
          </div>

          {/* Stats */}
          <div className="flex flex-nowrap justify-center gap-3 mb-7" data-id="element-221">
            <div className="flex flex-col items-center px-4 py-3 rounded-xl flex-1" style={{
            background: 'var(--bg-muted)',
            border: '1px solid var(--border-default)'
          }} data-id="element-222">
              <span className="text-2xl font-bold" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-gold)'
            }} data-id="element-223">
                +500
              </span>
              <span className="text-xs mt-0.5 text-center" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-224">
                Recetas Incluidas
              </span>
            </div>
            <div className="flex flex-col items-center px-4 py-3 rounded-xl flex-1" style={{
            background: 'var(--bg-muted)',
            border: '1px solid var(--border-default)'
          }} data-id="element-225">
              <span className="text-2xl font-bold" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-gold)'
            }} data-id="element-226">
                10
              </span>
              <span className="text-xs mt-0.5 text-center" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-227">
                Días Resueltos
              </span>
            </div>
            <div className="flex flex-col items-center px-4 py-3 rounded-xl flex-1" style={{
            background: 'var(--bg-muted)',
            border: '1px solid var(--border-default)'
          }} data-id="element-228">
              <span className="text-2xl font-bold" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-gold)'
            }} data-id="element-229">
                2 hs
              </span>
              <span className="text-xs mt-0.5 text-center" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-230">
                De Cocina Total
              </span>
            </div>
          </div>
        </div>

        {/* ── Main pitch ── */}
        <div className="rounded-2xl p-6 md:p-8 mb-8" style={{
        background: 'var(--bg-muted)',
        border: '1px solid var(--border-default)'
      }} data-id="element-231">
          <p className="text-base md:text-lg leading-relaxed m-0 font-[400]" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-secondary)'
        }} data-id="element-232">
            Resolvé la comida de{' '}
            <strong style={{
            color: 'var(--text-primary)',
            fontWeight: 700
          }} data-id="element-233">
              10 días enteros
            </strong>{' '}
            con el{' '}
            <strong style={{
            fontWeight: 700,
            color: 'var(--text-primary)',
            textDecoration: 'underline',
            textDecorationColor: 'var(--color-gold)',
            textUnderlineOffset: '3px',
            textDecorationThickness: '2px'
          }} data-id="element-234">
              sistema de 6 pasos
            </strong>
            ... incluso si llegás sin ganas de cocinar, con poco presupuesto o
            una cocina chiquita.
          </p>
        </div>

        {/* ── Cómo funciona ── */}
        <div className="mb-8" data-id="element-235">
          <div className="section-accent" data-id="element-236" />
          <p className="eyebrow text-center mb-2" data-id="element-237">El método paso a paso</p>
          <h2 className="text-2xl md:text-3xl text-center mb-2" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-238">
            ¿Cómo funciona el{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-239">
              Sistema 10x2™
            </span>
            ?
          </h2>
          <p className="text-sm text-center mb-6" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-muted)',
          maxWidth: '440px',
          margin: '0 auto',
          lineHeight: 1.6
        }} data-id="element-240">
            Un sistema completo con recetas, menús, listas de compras,
            calculadora y mucho más.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-3" data-id="element-241">
            {/* Paso 1 */}
            <div className="rounded-xl overflow-hidden flex flex-col" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-242">
              <div className="w-full overflow-hidden" style={{
              height: '110px'
            }} data-id="element-243">
                <img src="https://cdn.magicpatterns.com/uploads/5q5gthsDQztV4qyU67D34b/WhatsApp_Image_2026-03-05_at_10.38.55.jpg" alt="Paso 1 — Elegí un menú" className="w-full h-full object-cover object-top" style={{
                display: 'block'
              }} data-id="element-244" />
              </div>
              <div className="p-3" data-id="element-245">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-246">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style={{
                  background: 'var(--color-gold)'
                }} data-id="element-247">
                    1
                  </span>
                  <span className="text-xs font-bold uppercase" style={{
                  fontFamily: 'var(--font-body)',
                  color: 'var(--color-gold)',
                  letterSpacing: '0.06em'
                }} data-id="element-248">
                    Elegí
                  </span>
                </div>
                <p className="text-xs leading-snug m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-249">
                  Elegí{' '}
                  <strong style={{
                  color: 'var(--text-primary)'
                }} data-id="element-250">
                    1 de los 50 menús
                  </strong>{' '}
                  disponibles.
                </p>
              </div>
            </div>

            {/* Paso 2 */}
            <div className="rounded-xl overflow-hidden flex flex-col" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-251">
              <div className="w-full overflow-hidden" style={{
              height: '110px'
            }} data-id="element-252">
                <img src="https://cdn.magicpatterns.com/uploads/rS2R7c7e1UpA3L8g9YRZ3r/WhatsApp_Image_2026-03-05_at_10.39.31_(2).jpg" alt="Paso 2 — Organizá tu agenda" className="w-full h-full object-cover object-top" style={{
                display: 'block'
              }} data-id="element-253" />
              </div>
              <div className="p-3" data-id="element-254">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-255">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style={{
                  background: 'var(--color-gold)'
                }} data-id="element-256">
                    2
                  </span>
                  <span className="text-xs font-bold uppercase" style={{
                  fontFamily: 'var(--font-body)',
                  color: 'var(--color-gold)',
                  letterSpacing: '0.06em'
                }} data-id="element-257">
                    Organizá
                  </span>
                </div>
                <p className="text-xs leading-snug m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-258">
                  Organizá en tu agenda{' '}
                  <strong style={{
                  color: 'var(--text-primary)'
                }} data-id="element-259">
                    lo que va a comer tu familia
                  </strong>{' '}
                  cada día.
                </p>
              </div>
            </div>

            {/* Paso 3 */}
            <div className="rounded-xl overflow-hidden flex flex-col" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-260">
              <div className="w-full overflow-hidden" style={{
              height: '110px'
            }} data-id="element-261">
                <img src="https://cdn.magicpatterns.com/uploads/wgdgSNrPeohEQwtBLW5Mgz/WhatsApp_Image_2026-03-05_at_10.39.31_(1).jpg" alt="Paso 3 — Adaptá la lista" className="w-full h-full object-cover object-top" style={{
                display: 'block'
              }} data-id="element-262" />
              </div>
              <div className="p-3" data-id="element-263">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-264">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style={{
                  background: 'var(--color-gold)'
                }} data-id="element-265">
                    3
                  </span>
                  <span className="text-xs font-bold uppercase" style={{
                  fontFamily: 'var(--font-body)',
                  color: 'var(--color-gold)',
                  letterSpacing: '0.06em'
                }} data-id="element-266">
                    Adaptá
                  </span>
                </div>
                <p className="text-xs leading-snug m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-267">
                  Adaptá la lista de compra{' '}
                  <strong style={{
                  color: 'var(--text-primary)'
                }} data-id="element-268">
                    según tu familia
                  </strong>{' '}
                  y lo que ya tengas en casa.
                </p>
              </div>
            </div>

            {/* Paso 4 */}
            <div className="rounded-xl overflow-hidden flex flex-col" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-269">
              <div className="w-full overflow-hidden" style={{
              height: '110px'
            }} data-id="element-270">
                <img src="https://cdn.magicpatterns.com/uploads/dSp9g9Wqay93CFBKFcuubp/WhatsApp_Image_2026-03-05_at_10.39.31.jpg" alt="Paso 4 — Hacé tus compras" className="w-full h-full object-cover object-top" style={{
                display: 'block'
              }} data-id="element-271" />
              </div>
              <div className="p-3" data-id="element-272">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-273">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style={{
                  background: 'var(--color-gold)'
                }} data-id="element-274">
                    4
                  </span>
                  <span className="text-xs font-bold uppercase" style={{
                  fontFamily: 'var(--font-body)',
                  color: 'var(--color-gold)',
                  letterSpacing: '0.06em'
                }} data-id="element-275">
                    Comprá
                  </span>
                </div>
                <p className="text-xs leading-snug m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-276">
                  Hacé tus compras{' '}
                  <strong style={{
                  color: 'var(--text-primary)'
                }} data-id="element-277">
                    en solo 15 minutos
                  </strong>{' '}
                  con la lista exacta.
                </p>
              </div>
            </div>

            {/* Paso 5 */}
            <div className="rounded-xl overflow-hidden flex flex-col" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-278">
              <div className="w-full overflow-hidden" style={{
              height: '110px'
            }} data-id="element-279">
                <img src="https://cdn.magicpatterns.com/uploads/e4iXabQZ6DQ6xbnYRfqSmi/WhatsApp_Image_2026-03-05_at_10.40.12.jpg" alt="Paso 5 — Prepará las recetas" className="w-full h-full object-cover object-top" style={{
                display: 'block'
              }} data-id="element-280" />
              </div>
              <div className="p-3" data-id="element-281">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-282">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style={{
                  background: 'var(--color-gold)'
                }} data-id="element-283">
                    5
                  </span>
                  <span className="text-xs font-bold uppercase" style={{
                  fontFamily: 'var(--font-body)',
                  color: 'var(--color-gold)',
                  letterSpacing: '0.06em'
                }} data-id="element-284">
                    Cociná
                  </span>
                </div>
                <p className="text-xs leading-snug m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-285">
                  Prepará las recetas{' '}
                  <strong style={{
                  color: 'var(--text-primary)'
                }} data-id="element-286">
                    con nuestro paso a paso.
                  </strong>{' '}
                  ¿Dudas? Preguntá en nuestra comunidad de WhatsApp.
                </p>
              </div>
            </div>

            {/* Paso 6 */}
            <div className="rounded-xl overflow-hidden flex flex-col" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-287">
              <div className="w-full overflow-hidden" style={{
              height: '110px'
            }} data-id="element-288">
                <img src="https://cdn.magicpatterns.com/uploads/oNeLqWTWbYnwXrYjxQmFm2/WhatsApp_Image_2026-03-05_at_10.40.12_(1).jpg" alt="Paso 6 — Prepará y congelá tus comidas" className="w-full h-full object-cover object-center" style={{
                display: 'block'
              }} data-id="element-289" />
              </div>
              <div className="p-3" data-id="element-290">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-291">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold text-white" style={{
                  background: 'var(--color-gold)'
                }} data-id="element-292">
                    6
                  </span>
                  <span className="text-xs font-bold uppercase" style={{
                  fontFamily: 'var(--font-body)',
                  color: 'var(--color-gold)',
                  letterSpacing: '0.06em'
                }} data-id="element-293">
                    Congelá
                  </span>
                </div>
                <p className="text-xs leading-snug m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-294">
                  Prepará y{' '}
                  <strong style={{
                  color: 'var(--text-primary)'
                }} data-id="element-295">
                    congelá tus comidas.
                  </strong>{' '}
                  ¡10 días resueltos!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ── Inline pricing ── */}
        <div className="mb-8" data-id="element-296">
          {/* Price card */}
          <div className="rounded-2xl p-7 text-center mb-4" style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-sm)'
        }} data-id="element-297">
            <p className="eyebrow mb-4" data-id="element-298">Precio de oferta:</p>
            <p className="text-2xl line-through mb-1" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-299">
              $87.995 ARS
            </p>
            <p className="text-5xl font-bold mb-4" style={{
            fontFamily: 'var(--font-heading)',
            color: 'var(--color-primary)',
            lineHeight: 1.1,
            letterSpacing: '-0.02em'
          }} data-id="element-300">
              $19.999 ARS
            </p>
            <p className="text-sm m-0" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-301">
              Pago único · Sin suscripciones · Sin cargos ocultos
            </p>
          </div>
          {/* Gold CTA — outside the card */}
          <a href={CART_URL} onClick={trackAddToCart} className="btn-cta-gold btn-cta-gold-pulse w-full text-base md:text-lg px-6 py-4 rounded-xl mb-2 block text-center" data-id="element-302">
            QUIERO MI SISTEMA 10x2™ &gt;&gt;
          </a>
          <p className="text-sm text-center" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--color-accent)'
        }} data-id="element-303">
            ✓ Descarga inmediata de todo el paquete
          </p>
        </div>

        {/* ── Urgency + timer ── */}
        <div className="rounded-2xl p-6 text-center mb-10" style={{
        background: 'var(--bg-dark)'
      }} data-id="element-304">
          <p className="font-bold text-sm uppercase tracking-widest mb-2" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--color-gold)',
          letterSpacing: '0.18em'
        }} data-id="element-305">
            🔥 OFERTA SOLO POR HOY
          </p>
          <p className="text-sm mb-4" style={{
          fontFamily: 'var(--font-body)',
          color: 'rgba(255,255,255,0.55)'
        }} data-id="element-306">
            Reserva válida por 15 minutos. Si no accedés, tu descuento pasa a la
            siguiente persona.
          </p>
          <CountdownTimer data-id="element-307" />
        </div>

        {/* ── Results ── */}
        <div className="mb-2" data-id="element-308">
          <div className="section-accent" data-id="element-309" />
          <p className="eyebrow text-center mb-3" data-id="element-310">Resultados concretos</p>
          <h2 className="text-2xl md:text-3xl text-center mb-7" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-311">
            Esto es lo que vas a lograr con el{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-312">
              Sistema 10x2™
            </span>
          </h2>

          <div className="space-y-3" data-id="element-313">
            <div className="solution-card" data-id="element-314">
              <span className="text-xl flex-shrink-0" data-id="element-315">🍽️</span>
              <div data-id="element-316">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-317">
                  10 días de comida resueltos en solo 2 horas
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-318">
                  Abrís el freezer, elegís, calentás y servís.{' '}
                  <em data-id="element-319">Cero improvisación, cero estrés.</em>
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-320">
              <span className="text-xl flex-shrink-0" data-id="element-321">💰</span>
              <div data-id="element-322">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-323">
                  Hasta un{' '}
                  <span style={{
                  textDecoration: 'underline',
                  textDecorationColor: 'var(--color-gold)',
                  textUnderlineOffset: '3px'
                }} data-id="element-324">
                    40% menos de gasto en supermercado
                  </span>
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-325">
                  Comprás lo justo, en la cantidad justa. Se acabaron los
                  ingredientes que se pudren y las compras de impulso.
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-326">
              <span className="text-xl flex-shrink-0" data-id="element-327">🚫</span>
              <div data-id="element-328">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-329">
                  Chau delivery de culpa
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-330">
                  Dejás de tirar plata en comida cara y poco saludable por puro
                  agotamiento. <strong data-id="element-331">Esa plata vuelve a tu bolsillo.</strong>
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-332">
              <span className="text-xl flex-shrink-0" data-id="element-333">🌙</span>
              <div data-id="element-334">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-335">
                  Tus noches libres de vuelta
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-336">
                  Llegás del trabajo y la comida ya está lista. Nada de cocinar
                  1 hora después de una jornada agotadora.{' '}
                  <em data-id="element-337">Ese tiempo es tuyo.</em>
                </p>
              </div>
            </div>
            <div className="solution-card" data-id="element-338">
              <span className="text-xl flex-shrink-0" data-id="element-339">❄️</span>
              <div data-id="element-340">
                <p className="font-bold text-sm md:text-base m-0 mb-1" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-primary)'
              }} data-id="element-341">
                  Un freezer organizado que trabaja por vos
                </p>
                <p className="text-sm m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }} data-id="element-342">
                  Sabés exactamente qué tenés, qué usar primero y qué reponer.{' '}
                  <strong data-id="element-343">Cero desperdicio, cero "¿qué era esto?".</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}